export const SUBMARKET_BLOCKER_SUBMARKET_IN_UNFINISHED_AUCTION = 'submarket.blocker.submarketInUnfinishedAuction';
export const SUBMARKET_BLOCKER_USED_IN_AUCTION = 'usedInAuction';

export const transformSubmarketDeactivationBlockers = (t, blockerKey) => {
    let result;
    if (blockerKey === SUBMARKET_BLOCKER_SUBMARKET_IN_UNFINISHED_AUCTION) {
        result = t('submarkets.blocker.deactivation.submarket-in-unfinished-auction');
    } else {
        throw new Error(`Unknown blocker key: ${blockerKey}`);
    }
    return result;
};

export const transformSubmarketModificationBlockers = (t, blockerKey) => {
    let result;
    if (blockerKey === SUBMARKET_BLOCKER_USED_IN_AUCTION) {
        result = t('submarkets.blocker.modification.used-in-auction');
    } else {
        throw new Error(`Unknown blocker key: ${blockerKey}`);
    }
    return result;
};
